import { render, staticRenderFns } from "./RegionalEdit.vue?vue&type=template&id=5f5fabfe&"
import script from "./RegionalEdit.vue?vue&type=script&lang=js&"
export * from "./RegionalEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports